import React, { Component } from 'react'
import Link from '@components/Link'

import { playlistHeader, playlistDescription, playlistHeaderDescription, playlistHeaderTitle } from './style'

class PlaylistHeader extends Component {
  render() {
    const { showTitle, viewAllText, title, showViewAll, viewAllLink, description } = this.props
    return (
      <>
        {!description && (
          <div className={playlistHeader}>
            {showTitle && (
              <div>
                <h3>{title}</h3>
              </div>
            )}
            {showViewAll && <Link to={viewAllLink}>{(viewAllLink && viewAllText) || 'View All'}</Link>}
          </div>
        )}
        {description && (
          <>
            {showTitle && (
              <div className={playlistHeaderTitle}>
                <h3>{title}</h3>
              </div>
            )}
            <div className={playlistHeaderDescription}>
              <div className={playlistDescription}>{description}</div>
              {showViewAll && <Link to={viewAllLink}>{(viewAllLink && viewAllText) || 'View All'}</Link>}
            </div>
          </>
        )}
      </>
    )
  }
}

export default PlaylistHeader
